"use client";

import { Button } from "@/components/ui/button";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { debounce } from "@/ui/hooks/use-debounced-value";
import { Label } from "@/ui/shadcn/label";
import { StatefulColorPicker } from "@/ui/stateful-color-picker";
import { StatefulInput } from "@/ui/stateful-input";
import type { BannerSection } from "@/ui/yns-components/components/banner-section/banner-section";
import { useState } from "react";
import type { YnsComponentForm } from "../types";

export const BannerSectionForm: YnsComponentForm<typeof BannerSection> = ({ data, theme }) => {
	const context = useStoreBuilderContext<typeof BannerSection>();

	const currentlySelectedDate = data.targetDate ? new Date(data.targetDate).toISOString().slice(0, 10) : null;
	const [date, setDate] = useState(currentlySelectedDate);

	return (
		<div className="grid gap-4 relative pb-20">
			<Label className="grid gap-2">
				<span>Banner text</span>
				<StatefulInput
					defaultValue={data.text}
					name="text"
					onBlur={(e) => {
						if (e.currentTarget.value === data.text) {
							return;
						}
						context.saveSelectedPageSectionField({ fieldPath: "text", value: e.currentTarget.value });
					}}
				/>
			</Label>
			<Label className="grid gap-2">
				<span>Target date</span>
				<StatefulInput
					key={date}
					value={date ?? ""}
					onValueChange={(v) => {
						setDate(v);
						context.saveSelectedPageSectionField({ fieldPath: "targetDate", value: v });
					}}
					name="targetDate"
					type="date"
					onBlur={(e) => {
						if (e.currentTarget.value === currentlySelectedDate) {
							return;
						}
						setDate(e.currentTarget.value);
						context.saveSelectedPageSectionField({ fieldPath: "targetDate", value: e.currentTarget.value });
					}}
				/>
			</Label>
			<div className="grid 2xl:grid-cols-2 gap-4">
				<Label className="grid gap-2">
					<span>Background Color</span>
					<StatefulColorPicker
						defaultValue={theme?.backgroundColor}
						onValueChange={debounce(
							(value) => {
								context.saveSelectedPageSectionThemeField({
									fieldPath: "backgroundColor",
									value,
								});
							},
							300,
							{ trailing: true },
						)}
					/>
				</Label>
				<Label className="grid gap-2">
					<span>Text Color</span>
					<StatefulColorPicker
						defaultValue={theme?.textColor}
						onValueChange={debounce(
							(value) => {
								context.saveSelectedPageSectionThemeField({
									fieldPath: "textColor",
									value,
								});
							},
							300,
							{ trailing: true },
						)}
					/>
				</Label>
			</div>
			<Button
				variant="outline"
				size="sm"
				type="button"
				onClick={() => {
					setDate(null);
					context.saveSelectedPageSectionField({ fieldPath: "targetDate", value: null });
				}}
			>
				Clear date
			</Button>
		</div>
	);
};
